import { AnyAction, Middleware } from 'redux';
import { browserHistory } from 'react-router';
import { Dispatch } from 'ha/myredux/types';
import {
  isConnectionUpdatedAction,
  isConversationMessageAction,
  isConversationReadAction,
} from 'ha/modules/RealtimeMessaging/utils';
import reportError from 'ha/helpers/bugsnag/reportError';
import { RootState } from '../types';

const realtime: Middleware<Dispatch, RootState, Dispatch> = ({
  dispatch,
  getState,
}) => next => (action: AnyAction) => {
  next(action);

  if (
    isConversationMessageAction(action) ||
    isConversationReadAction(action) ||
    isConnectionUpdatedAction(action)
  ) {
    Promise.all([
      import(/* webpackChunkName: "ha-pages-Inbox-index-js" */ '../actions'),
      import(/* webpackChunkName: "ha-pages-Inbox-index-js" */ '../selectors'),
    ])
      .then(([actions, selectors]) => {
        const state = getState();
        const isInitialState = selectors.getInboxState(state)?.initial;

        if (isInitialState === undefined) return;

        dispatch(actions.loadInbox(browserHistory.getCurrentLocation().query));
      })
      .catch(reportError);
  }
};

export default realtime;
